import React from 'react'

const Home = () => {
    return (
        <div className="home-container">
            <div className='countdown'></div>
            <h1 className="home">Spectacle</h1>
            <h2 className="promo">Take Control of Your Entertainment</h2>
        </div>
    )
}

export default Home
